import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';

const initialState = {
  saveInProgress: false,
  saveError: null,
  settingsSaved: false,
};

const saveFulfilmentSettingsPayloadCreator = (
  {
    defaultDeliveryOptions,
    defaultCollectionLocation,
    defaultGeolocation,
    defaultLocalDeliveryFeeInSubunits,
    defaultLocalDeliveryRadiusInMiles,
    defaultCourierDeliveryFeeInSubunits,
    defaultLocalDeliveryNotes,
    defaultCourierDeliveryNotes,
    freeDeliveryEnabled,
    freeDeliveryThresholdInSubunits,
  },
  { dispatch, extra: sdk, rejectWithValue }
) => {
  const protectedData = {
    defaultDeliveryOptions: defaultDeliveryOptions || [],
    defaultCollectionLocation: defaultCollectionLocation || null,
    defaultGeolocation: defaultGeolocation || null,
    defaultLocalDeliveryFeeInSubunits:
      defaultLocalDeliveryFeeInSubunits != null ? defaultLocalDeliveryFeeInSubunits : null,
    defaultLocalDeliveryRadiusInMiles:
      defaultLocalDeliveryRadiusInMiles != null ? defaultLocalDeliveryRadiusInMiles : null,
    defaultCourierDeliveryFeeInSubunits:
      defaultCourierDeliveryFeeInSubunits != null ? defaultCourierDeliveryFeeInSubunits : null,
    defaultLocalDeliveryNotes: defaultLocalDeliveryNotes != null ? defaultLocalDeliveryNotes : null,
    defaultCourierDeliveryNotes:
      defaultCourierDeliveryNotes != null ? defaultCourierDeliveryNotes : null,
    freeDeliveryEnabled: !!freeDeliveryEnabled,
    freeDeliveryThresholdInSubunits: freeDeliveryEnabled
      ? freeDeliveryThresholdInSubunits || null
      : null,
  };

  return sdk.currentUser
    .updateProfile(
      { protectedData },
      {
        expand: true,
        include: ['profileImage'],
        'fields.image': ['variants.square-small', 'variants.square-small2x'],
      }
    )
    .then(response => {
      dispatch(fetchCurrentUser({ updateHasListings: false, updateNotifications: false }));
      return response.data.data;
    })
    .catch(e => {
      return rejectWithValue(storableError(e));
    });
};

export const saveFulfilmentSettingsThunk = createAsyncThunk(
  'FulfilmentSettingsPage/saveFulfilmentSettings',
  saveFulfilmentSettingsPayloadCreator
);

export const saveFulfilmentSettings = params => dispatch => {
  return dispatch(saveFulfilmentSettingsThunk(params)).unwrap();
};

const fulfilmentSettingsPageSlice = createSlice({
  name: 'FulfilmentSettingsPage',
  initialState,
  reducers: {
    clearSaveResults: state => {
      state.settingsSaved = false;
      state.saveError = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(saveFulfilmentSettingsThunk.pending, state => {
        state.saveInProgress = true;
        state.saveError = null;
        state.settingsSaved = false;
      })
      .addCase(saveFulfilmentSettingsThunk.fulfilled, state => {
        state.saveInProgress = false;
        state.saveError = null;
        state.settingsSaved = true;
      })
      .addCase(saveFulfilmentSettingsThunk.rejected, (state, action) => {
        state.saveInProgress = false;
        state.saveError = action.payload;
        state.settingsSaved = false;
      });
  },
});

export const { clearSaveResults } = fulfilmentSettingsPageSlice.actions;

export default fulfilmentSettingsPageSlice.reducer;

export const loadData = () => dispatch => {
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions));
};
